/**
 * Cart Lens Builder Button Handlers
 * Handles Change, Delete, and Add Another buttons for lens configurations in cart
 */

(function() {
  'use strict';
  
  console.log('🔘 Cart lens buttons script loaded');
  
  function initCartButtonHandlers() {
    // Check if we're on a page with lens control buttons
    const hasButtons = document.querySelector('.lens-control-change, .lens-control-delete, .lens-control-add-another');
    
    if (!hasButtons) {
      console.log('ℹ️ No lens control buttons found on this page');
      return;
    }
    
    console.log('🔘 Initializing cart button handlers');
    
    // CHANGE BUTTON - reload lens builder with existing config
    document.querySelectorAll('.lens-control-change').forEach(button => {
      console.log('Found Change button:', button);
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const lensKey = this.dataset.lensKey;
        console.log('✏️ Change clicked for lens:', lensKey);
        
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const parentItem = cart.items.find(item => 
              item.properties._lens_key === lensKey && 
              item.properties._is_lens_parent === 'true'
            );
            
            if (parentItem && parentItem.properties._config_data) {
              try {
                const configData = JSON.parse(parentItem.properties._config_data);
                
                sessionStorage.setItem('lensBuilderEditConfig', JSON.stringify(configData));
                sessionStorage.setItem('lensBuilderEditKey', lensKey);
                sessionStorage.setItem('lensBuilderFromCart', 'true');
                
                console.log('✅ Config saved to sessionStorage, redirecting...');
                
                // UPDATE THIS URL to your actual lens builder page
                window.location.href = '/pages/lens-builder';
              } catch (err) {
                console.error('Error parsing config data:', err);
                alert('Unable to load lens configuration. Please try again.');
              }
            } else {
              console.error('Parent item not found or missing config data');
              alert('Unable to find lens configuration.');
            }
          })
          .catch(err => {
            console.error('Error fetching cart:', err);
            alert('Error loading cart data. Please try again.');
          });
      });
    });
    
    // DELETE BUTTON - remove lens and all upgrades
    document.querySelectorAll('.lens-control-delete').forEach(button => {
      console.log('Found Delete button:', button);
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const lensKey = this.dataset.lensKey;
        console.log('🗑️ Delete clicked for lens:', lensKey);
        
        if (!confirm('Are you sure you want to remove this lens configuration from your cart?')) {
          return;
        }
        
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const itemsToRemove = cart.items.filter(item => 
              item.properties._lens_key === lensKey
            );
            
            console.log(`🔍 Found ${itemsToRemove.length} items to remove`);
            
            if (itemsToRemove.length === 0) {
              console.warn('⚠️ No items found with lens key:', lensKey);
              alert('Unable to find items to remove.');
              return;
            }
            
            // Remove items sequentially to avoid conflicts
            async function removeItemsSequentially() {
              for (const item of itemsToRemove) {
                console.log('🗑️ Removing item:', item.key, item.product_title);
                try {
                  const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: item.key,
                      quantity: 0
                    })
                  });
                  
                  if (!response.ok) {
                    console.error(`❌ Failed to remove ${item.product_title}:`, response.status);
                  } else {
                    console.log(`✅ Removed ${item.product_title}`);
                  }
                } catch (err) {
                  console.error(`❌ Error removing ${item.product_title}:`, err);
                }
              }
              
              console.log('✅ All items processed, reloading...');
              window.location.reload();
            }
            
            removeItemsSequentially();
          })
          .catch(err => {
            console.error('❌ Error fetching cart:', err);
            alert('Error loading cart data. Please try again.');
          });
      });
    });


    
    // ADD ANOTHER BUTTON - open fresh lens builder
    document.querySelectorAll('.lens-control-add-another').forEach(button => {
      console.log('Found Add Another button:', button);
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('➕ Add Another clicked');
        
        sessionStorage.removeItem('lensBuilderEditConfig');
        sessionStorage.removeItem('lensBuilderEditKey');
        
        console.log('✅ SessionStorage cleared, redirecting...');
        
        // UPDATE THIS URL to your actual lens builder page
        window.location.href = '/pages/lens-builder';
      });
    });
    
    console.log('✅ Cart button handlers initialized');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartButtonHandlers);
  } else {
    initCartButtonHandlers();
  }
  
})();
